<div class="modal-overlay">
    <div class="modal-container">
        <div class="modal-header">
            <h2 class="ra-header-s">{{ 'document.preview.confirmCode.title' | translate }}</h2>
        </div>

        <div class="modal-body">
            <p class="ra-label-s">{{ 'document.preview.confirmCode.instruction' | translate }}</p>

            <div
                class="code-field"
                role="group"
                [attr.aria-label]="'document.preview.confirmCode.fieldGroupAria' | translate: { length: codeLength }">
                @for (index of digitIndexes; track index) {
                    <input
                        #digitInput
                        class="code-field__digit"
                        type="text"
                        inputmode="text"
                        pattern="[A-Za-z0-9]*"
                        maxlength="1"
                        autocomplete="off"
                        autocapitalize="off"
                        autocorrect="off"
                        spellcheck="false"
                        [attr.name]="'digit-field-' + index"
                        [value]="otpDigits()[index]"
                        [attr.aria-label]="'document.preview.confirmCode.digitAria' | translate: { current: index + 1, length: codeLength }"
                        (input)="handleDigitInput(index, $event)"
                        (keydown)="handleDigitKeydown(index, $event)"
                        (paste)="handleDigitPaste(index, $event)"
                    />
                }
            </div>

            @if (showResendSection()) 
            {
                <div class="resend-section">
                    <p class="resend-section__hint ra-label-s">{{ 'document.preview.confirmCode.resendHint' | translate }}</p>
    
                    <div class="resend-form">
                        <div class="resend-form__email">
                            <ra-input
                                [formControl]="emailFormControl"
                                [type]="'email'"
                                [placeholder]="emailPlaceholder() || ('document.preview.confirmCode.emailPlaceholder' | translate)"
                                [showRequiredOrOptional]="false"
                                [showLimitCharacters]="false"
                            />
                        </div>
                        <div class="resend-form__action">
                            <ra-button
                                [label]="'document.preview.confirmCode.resendButton' | translate"
                                [loading]="resendLoading()"
                                [disabled]="!canResend()"
                                (click)="handleResend()"
                            />
                        </div>
                    </div>
                </div>
            }
        </div>

        <div class="modal-footer">
            <ra-button
                [label]="'common.confirm' | translate"
                [icon]="'check'"
                [loading]="confirmLoading()"
                [disabled]="!canConfirm() || confirmLoading()"
                (click)="handleConfirm()"
            />
        </div>
    </div>
</div>
